<template>
  <div class="page-container">
    <div class="query-title">进货折扣券活动查询</div>
    <div class="content">
      <QueryParams
        ref="QueryParams"
        :loading="loading"
        :search-field="searchField"
        @search="queryData"
      />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="通过" @click="changeStatus('SUBMIT')" />
            <table-button name="export" tip="驳回" @click="changeStatus('CANCEL')" />
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="600"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :cell-style="rowClassName"
            @filter-change="filterChangeEvt"
            :span-method="mergeRowMethod"
          >
            <template #fee_code="{ row }">
              <span :class="row.flag ? '' : 'blue'" @click="goOrderDetail(row)">{{
                row.fee_code
              }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>
    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="所选数据"
      :visible.sync="showDialog"
      width="30%"
      :append-to-body="true"
    >
      <template>
        <div>共选：{{ checkData.length }}单，总金额：{{ totalAmount.toFixed(3) }}元。</div>
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          :loading="loading"
          icon="el-icon-circle-close"
          @click="showDialog = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          :loading="loading"
          icon="el-icon-circle-check"
          @click="submitHandle"
          >{{ confirmBtn }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDhk, getSubmitDhk } from '@/api/sap/signing-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/loanQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  components: {},
  data() {
    return {
      pageSearch,
      searchField: {},
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        columns: [{ type: 'radio', field: 'radio', title: '', width: 40 }],
        data: []
      },
      showDialog: false,
      modeType: '',
      checkData: [],
      totalAmount: 0,
      confirmBtn: ''
    }
  },
  props: {},
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    // 根据flag添加样式
    // rowClassName(row, rowIndex) {
    //   if (row.row.flag) {
    //     return { color: 'red' }
    //   }
    //   return ''
    // },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      // fields是哪些需要合并的单元格
      const fields = [
        'fee_code',
        'radio',
        'terminal_code',
        'terminal_name',
        'dealer_code',
        'dealer_name',
        'dealer_code',
        'product_code',
        'product_name',
        'state_text',
        'total_amount',
        'create_date',
        'audit_date'
      ]
      if (fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        // 当满足以下条件才去合并上面的单元格
        if (prevRow && prevRow['fee_code'] === row['fee_code']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['fee_code'] === row['fee_code']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    async submitHandle(mode, data) {
      const params = {
        mode,
        user_bp: this.$store.getters.role.USER_BP,
        data
      }
      const res = await getSubmitDhk(params)
      if (res.msgtype === 'E') {
        this.$message.warning(res.message)
        return
      }
      this.$message.success(res.message)
      this.queryData()
      this.showDialog = false
    },
    async changeStatus(mode) {
      const data = this.$refs.xTable.getRadioRecord()
      const msg = '该折扣申请' + data.state_text
      if (!data.fee_code || data.state != '0') {
        this.$message.warning(msg)
        return
      }
      if (mode=='SUBMIT' && data.flag) {
        this.$confirm('该终端本次申请使用'+data.sheet_num+'张进货折扣券，需进货'+data.sheet_num+'件使用。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.submitHandle(mode, [data])
          })
          .catch(() => {

          })
      } else {
        this.submitHandle(mode, [data])
      }
      // return
      // this.modeType = mode
      // this.checkData = checkData
      // this.totalAmount = 0
      // this.checkData.forEach(ele => {
      //   this.totalAmount += (ele.total_amount-0)
      // });
      // this.showDialog = true
      // this.confirmBtn = mode === 'SUBMIT' ? '确认通过' :'确认驳回'
    },
    goOrderDetail(row) {
      this.$router.push({
        path: '/wly/loan-manage/loan-detail',
        query: {
          code: row.fee_code
          // order_type: row.order_type,
          // status: row.status,
        }
      })
    },
    // 导出全部 导出本页
    async exportExcel() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length) {
        frontExport(this.gridOptions.columns, checkData, '销售折扣数据报表')
        return
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getDhk)
      frontExport(this.gridOptions.columns, data, '销售折扣数据报表')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        flag:"X",
        ...this.pagination,
        is_result: 1,
        // sort: this.sortData.concat(this.tableSort),
        ...this.allConditions
      }
      this.loading = true
      try {
        const { data, total, calculation, field } = await getDhk(params)
        if (data.length === 0 && total - 0) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
.redColor {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/loan-manage/loan-query-special.vue